var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconToxicBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#c1ea76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9563,
    stopColor: "#a1e66b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ee66a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(1 0 0 -1 0 814.814)",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 307.316,
    y2: 330.445
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.154,
    x2: 323.73,
    xlinkHref: "#lg1",
    y1: 317.411,
    y2: 317.411
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(-1 0 0 -1 -1618.004 -1680.274)",
    gradientUnits: "userSpaceOnUse",
    x1: -1920.929,
    x2: -1823.572,
    xlinkHref: "#lg1",
    y1: -2055.474,
    y2: -1958.117
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ee66a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1524,
    stopColor: "#93e267",
    stopOpacity: 0.152
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4172,
    stopColor: "#77d660",
    stopOpacity: 0.417
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7603,
    stopColor: "#49c254",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25b34b"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.747,
    x2: 209.237,
    xlinkHref: "#lg2",
    y1: 474.648,
    y2: 22.813
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.425,
    x2: 254.425,
    xlinkHref: "#lg1",
    y1: 120.735,
    y2: 157.526
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.251,
    x2: 255.251,
    xlinkHref: "#lg1",
    y1: 3.921,
    y2: 40.173
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.425,
    x2: 254.425,
    xlinkHref: "#lg1",
    y1: 31.99,
    y2: 68.241
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 68.707,
    y2: 122.543
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.425,
    x2: 254.425,
    xlinkHref: "#lg2",
    y1: 440.354,
    y2: 507.047
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.323,
    x2: 177.613,
    xlinkHref: "#lg2",
    y1: 434.351,
    y2: 330.641
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.146,
    x2: 235.201,
    xlinkHref: "#lg2",
    y1: 361.285,
    y2: 252.34
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.122,
    x2: 245.815,
    xlinkHref: "#lg2",
    y1: 383.56,
    y2: 322.253
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.594,
    x2: 304.417,
    xlinkHref: "#lg2",
    y1: 406.736,
    y2: 357.559
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.604,
    x2: 272.393,
    xlinkHref: "#lg3",
    y1: 331.432,
    y2: 331.432
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.87,
    x2: 304.128,
    xlinkHref: "#lg3",
    y1: 273.218,
    y2: 273.218
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.559,
    x2: 340.388,
    xlinkHref: "#lg3",
    y1: 364.348,
    y2: 364.348
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.609,
    x2: 243.438,
    xlinkHref: "#lg3",
    y1: 364.348,
    y2: 364.348
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m359.986 474.182h-209.972v16.184c0 10.844 8.79 19.634 19.634 19.634h170.703c10.844 0 19.634-8.79 19.634-19.634v-16.184z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.085 492.091h-177.32c-26.36 0-48.459-19.916-51.191-46.134l-31.598-303.226h342.898l-31.598 303.226c-2.732 26.218-24.831 46.134-51.191 46.134z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 254.998,
    cy: 327.274,
    fill: "url(#SVGID_3_)",
    r: 114.434
  })), /*#__PURE__*/React.createElement("path", {
    d: "m385.382 469.946c4.801-6.916 7.966-15.087 8.894-23.989l31.598-303.226h-342.898l2.886 27.695z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.204 171.322h-325.558c-10.526 0-19.059-8.533-19.059-19.059v-14.686c0-10.526 8.533-19.059 19.059-19.059h325.559c10.526 0 19.059 8.533 19.059 19.059v14.686c-.001 10.526-8.534 19.059-19.06 19.059z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m398.483 56.137h-286.465v-27.426c0-15.857 12.854-28.711 28.711-28.711h229.044c15.856 0 28.711 12.854 28.711 28.711v27.426z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.923 84.206h-334.996c-7.92 0-14.34-6.42-14.34-14.34v-13.087c0-15.856 12.854-28.711 28.711-28.711h306.255c15.856 0 28.711 12.854 28.711 28.711v13.087c-.001 7.92-6.421 14.34-14.341 14.34z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m442.088 142.731h-374.176c-10.651 0-19.285-8.634-19.285-19.285v-38.698c0-10.651 8.634-19.285 19.285-19.285h374.176c10.651 0 19.285 8.634 19.285 19.285v38.698c0 10.651-8.634 19.285-19.285 19.285z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.198 394.366 5.376 51.592c2.732 26.218 24.831 46.134 51.191 46.134h177.32c26.36 0 48.459-19.916 51.191-46.134l5.376-51.592z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m314.92 424.785c-2.111 1.303-4.274 2.537-6.471 3.695-15.955 8.446-34.141 13.231-53.451 13.231-3.678 0-7.314-.17-10.898-.511l-47.44-47.44c-16.645-15.581-27.049-37.734-27.049-62.331 0-1.056.017-2.111.051-3.159.119-3.201 2.631-5.807 5.815-6.011l32.907-2.06c2.937-.187 5.372 1.677 6.224 4.274l52.489 52.48z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.436 327.793c-.043 8.684-1.047 17.139-2.912 25.261-3.797 16.458-11.136 31.561-21.183 44.46-3.312 4.266-6.922 8.284-10.804 12.03l-109.465-109.464c-1.447-.485-2.724-1.498-3.491-3.005l-15.036-29.373c-1.439-2.835-.519-6.317 2.145-8.037 13.333-8.616 29.229-13.622 46.308-13.622s32.975 5.006 46.308 13.622z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.341 397.515c-3.312 4.266-6.922 8.284-10.804 12.03-4.368 4.231-9.076 8.114-14.082 11.605l-51.544-51.544-24.052-24.044c-4.393-3.15-7.254-8.31-7.254-14.133 0-5.168 2.256-9.808 5.832-12.984 3.074-2.75 7.126-4.41 11.562-4.41 5.824 0 10.975 2.869 14.125 7.262l23.814 23.805z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.524 353.054c-3.797 16.458-11.136 31.561-21.183 44.46-3.312 4.266-6.922 8.284-10.804 12.03-4.368 4.231-9.076 8.114-14.082 11.605-1.805 1.26-3.652 2.478-5.534 3.635-2.111 1.303-4.274 2.537-6.471 3.695l-20.298-20.383c-1.217-.46-2.299-1.311-3.039-2.486l-17.599-27.892c-.162-.247-.298-.502-.417-.766-1.175-2.588-.358-5.585 1.814-7.348.468-.383 1.005-.707 1.609-.954.026-.008.051-.017.068-.026 5.177-2.188 9.808-5.406 13.614-9.417 3.823-4.01 6.82-8.804 8.735-14.108 1.541-4.274 2.384-8.872 2.384-13.674 0-1.388-.068-2.784-.221-4.172 0-.026 0-.051-.009-.085-.383-3.865 2.631-7.211 6.522-6.973l32.898 2.06c2.605.17 4.742 1.924 5.517 4.3z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 254.999,
    cy: 331.432,
    fill: "url(#SVGID_14_)",
    r: 17.394
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.446 267.697-15.028 29.383c-1.773 3.466-6.199 4.341-9.321 2.013-.021-.016-.042-.031-.063-.047-6.705-4.997-15.022-7.938-24.036-7.938-9.013 0-17.331 2.941-24.035 7.938-.021.015-.042.031-.063.047-3.121 2.327-7.548 1.453-9.321-2.014l-15.028-29.383c-1.446-2.828-.526-6.306 2.141-8.031 13.326-8.615 29.222-13.624 46.306-13.624s32.98 5.009 46.306 13.624c2.668 1.726 3.588 5.205 2.142 8.032z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m340.388 331.432c0 33.441-19.219 62.38-47.225 76.411-2.857 1.432-6.343.473-8.049-2.23l-17.606-27.891c-2.081-3.297-.587-7.569 3.012-9.07.023-.01.047-.02.07-.029 14.516-6.104 24.731-20.462 24.731-37.192 0-1.391-.063-2.783-.221-4.175-.003-.026-.005-.052-.008-.078-.385-3.873 2.633-7.22 6.517-6.977l32.902 2.065c3.198.201 5.701 2.806 5.818 6.008.039 1.05.059 2.102.059 3.158z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.489 377.723-17.606 27.891c-1.706 2.702-5.192 3.661-8.049 2.23-28.006-14.032-47.225-42.971-47.225-76.411 0-1.056.02-2.108.058-3.157.118-3.202 2.621-5.807 5.818-6.008l32.902-2.065c3.885-.244 6.903 3.104 6.517 6.977-.003.026-.005.052-.008.078-.158 1.392-.221 2.783-.221 4.175 0 16.73 10.215 31.088 24.731 37.192.023.01.047.02.07.029 3.6 1.5 5.094 5.772 3.013 9.069z",
    fill: "url(#SVGID_17_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToxicBin);
export default __webpack_public_path__ + "static/media/icon-toxic-bin.ac76b5952cf1ca8b3d65414fab5528c1.svg";
export { ForwardRef as ReactComponent };